export const messages = {
  en: {
    chooseOrg: {
      title: 'Select Organization',
      orgId: 'Org ID',
      orgName: 'Org Name', 
      orgLevel: 'Org Level',
      parentOrg: 'Parent Org',
      operation: 'Operation',
      select: 'Select',
      searchPlaceholder: 'Enter org name'
    }
  },
  zh: {
    chooseOrg: {
      title: '选择组织',
      orgId: '组织ID',
      orgName: '组织名称',
      orgLevel: '组织级别',
      parentOrg: '上级组织',
      operation: '操作',
      select: '选择',
      searchPlaceholder: '输入组织名称'
    }
  }
}